import { t } from 'i18next';
import { z } from 'zod';
import { InputRegexMap, OnboardingFormFields } from '@Types/index';
import { Line1Schema } from '@Components/inputs/Line1';
import { AddressStateSchema } from '@Components/inputs/AddressStateDropDown';
import { LiliDropdownItem } from '@lili/lili-frontend-common';
import { zipSchema } from '@Components/inputs/ZipAddress/';

const MAX_CITY_CHARS = 21;

export const createSchema = () => {
  return z.object({
    ...Line1Schema.shape,

    [OnboardingFormFields.APARTMENT]: z.string().describe('apt').optional(),
    [OnboardingFormFields.CITY]: z
      .string()
      .min(1, t('enErrors:address.city.required'))
      .min(2, t('enErrors:address.city.min'))
      .max(
        MAX_CITY_CHARS,
        t('enErrors:address.city.max', {
          max: MAX_CITY_CHARS,
        })
      )
      .regex(InputRegexMap.cityUS, t('enErrors:address.city.invalid')),
    ...zipSchema.shape,
    ...AddressStateSchema.shape,

    [OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY]: z.boolean().optional().default(false),
  });
};

export const BusinessAddressSchema = createSchema();

export interface IBusinessAddressForm {
  [OnboardingFormFields.LINE1]: string;
  [OnboardingFormFields.APARTMENT]: string;
  [OnboardingFormFields.CITY]: string;
  [OnboardingFormFields.STATE]: LiliDropdownItem | null;
  [OnboardingFormFields.ZIP]: string;
  [OnboardingFormFields.BUSINESS_ADDRESS_SAME_AS_PRIMARY]: boolean;
}
